//////////////////////////////////////////////////////////////////////
// Configurations related to search                                 //
// Note: some search experience is also on defaultMapsConfig        //
// and defaultListingConfig.js is responsible public data filtering //
//////////////////////////////////////////////////////////////////////

// NOTE: if you want to change the structure of the data,
// you should also check src/util/configHelpers.js
// some validation is added there.

// Main search used in Topbar.
// This can be either 'keywords' or 'location'.
// Note: The mainSearch comes from the listing-search asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeSearchConfig func)
export const mainSearch = {
  searchType: 'location',
};

/**
 * Configuration for default filters.
 * These are custom configs for each filter.
 * Common properties: key, schemaType, and label.
 * Note: the order of default filters is defined in util/configHelpers.js
 * To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeSearchConfig func)
 */

export const listingTypeFilter = {
  enabled: false,
  schemaType: 'listingType',
  // schemaType, key, and other built-in config values are completely filled in configHelper.js
};

export const categoryFilter = {
  enabled: false,
  schemaType: 'category',
  // schemaType, key, and other built-in config values are completely filled in configHelper.js
};

export const dateRangeFilter = {
  schemaType: 'dates',
  // NOT READ ANY MORE — changing this changes nothing. src/util/searchDates.js decides
  // `availability` per date context now: 'time-full' over a single day or an explicit range,
  // 'time-partial' with a one-day minDuration over a whole month. It can ask the API that exact
  // question because this marketplace sits entirely in Europe/Zurich; stock Sharetribe padded
  // its window in Etc/UTC to cover every zone and so could only ever ask for 'time-partial',
  // which is what this knob existed to admit. Kept only so the object still matches the shape
  // of the hosted listing-search asset.
  availability: 'time-full', // time-partial
  // Options: day/night. This no longer reaches the QUERY — searchDates.js derives the window
  // from the `dates` param alone — but it is still read by the PICKERS: FilterComponent.js and
  // the PageBuilder SearchCTA both turn 'night' into minimumNights: 1 on the stock
  // check-in/check-out controller. It has no effect at all when dateSearch is on, since the
  // day/month picker has no check-out date to count nights between.
  dateRangeMode: 'day',
  // Feature gate for the flexible-date search work (spec 2026-08-22).
  // NOTE: this value is NOT what decides the gate. The hosted listing-search asset replaces
  // dateRangeFilter wholesale in every environment that has one, so the live value is read
  // from REACT_APP_DATE_SEARCH_ENABLED in util/configHelpers.js (mergeSearchConfig). This
  // entry only documents the key and serves the no-hosted-asset case.
  dateSearch: false,
};

/**
 * Note: the order of default filters is defined in util/configHelpers.js
 * To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeSearchConfig func)
 */
export const priceFilter = {
  schemaType: 'price',
  // Note: unlike most prices this is not handled in subunits
  min: 0,
  max: 1000,
  step: 5,
};
// // This is not in use by default.
// export const keywordsFilter = {
//   key: 'keywords',
//   schemaType: 'keywords',
// }

export const sortConfig = {
  // Enable/disable the sorting control in the SearchPage
  active: true,

  // Note: queryParamName 'sort' is fixed,
  // you can't change it since Marketplace API expects it to be named as 'sort'
  queryParamName: 'sort',

  // Internal key for the relevance option, see notes below.
  relevanceKey: 'relevance',

  // Relevance key is used with keywords filter.
  // Keywords filter also sorts results according to relevance.
  relevanceFilter: 'keywords',

  // Keyword filter is sorting the results by relevance.
  // If keyword filter is active, one might want to disable other sorting options
  // by adding 'keywords' to this list.
  conflictingFilters: [],

  options: [
    // These are default sort options
    { key: 'createdAt', labelTranslationKey: 'SortBy.newest' },
    { key: '-createdAt', labelTranslationKey: 'SortBy.oldest' },
    { key: '-price', labelTranslationKey: 'SortBy.lowestPrice' },
    { key: 'price', labelTranslationKey: 'SortBy.highestPrice' },
    // If you add own sort options, you can also use label key: { key: 'meta_rating', label: 'Highest rated' },

    // The relevance is only used for keyword search, but the
    // parameter isn't sent to the Marketplace API. The key is purely
    // for handling the internal state of the sorting dropdown.
    {
      key: 'relevance',
      labelTranslationKey: 'SortBy.relevance',
      labelTranslationKeyLong: 'SortBy.relevanceLong',
    },
  ],
};
